<template>
  <div id="home">
    <section class="text-center pt-4 pb-2 bg-white" >
      <CategoriasProducto></CategoriasProducto>
    </section>
    <div class="home-slider">
      <slider></slider>
    </div>
    
    <section class="recommended-section" >
      <div class="container">
        <div class="section-header text-center mb-5">
          <span class="badge rounded-pill text-white mb-2 px-3 py-2 shadow-sm" style="background-color: #cc161d; font-weight: 600; letter-spacing: 1.5px; font-size: 0.8rem;">
            🔥 TOP VENTAS
          </span>
          <h2 class="fw-bold mb-3 mt-2" style="color: #2c3e50; font-size: 2.5rem; letter-spacing: -0.5px;">
            Los Más <span style="color: #713083;">Elegidos</span>
          </h2>
          <p class="text-muted mx-auto" style="max-width: 600px; font-size: 1.1rem; line-height: 1.6;">
            Descubre los empaques y soluciones que más solicitan nuestros clientes. Calidad, resistencia y diseño comprobado.
          </p>
        </div>
        
        <Products limit="8" :items="populares" gridClass="col-12 col-md-4 col-lg-3 mb-4 px-3"></Products>
        
        <div class="text-center mt-5">
          <router-link to="/store" class="btn-premium">
            <span>Explorar Todo El Catálogo</span>
          </router-link>
        </div>
      </div>
    </section>


    <section class="py-5" style="background-color: #2c3e50; color: white; border-top: 5px solid #e74c3c; border-bottom: 5px solid #e74c3c;">
      <div class="container text-center">
        <IconosHome></IconosHome>
      </div>
    </section>

  </div>
</template>

<script>
  import axios from 'axios'
  import Eheader from '@/components/layout/Eheader.vue'
  import Efooter from '@/components/layout/Efooter.vue'

  import Products from '@/components/Products.vue'
  import CategoriasProducto from '@/components/CategoriasProducto.vue'
  import IconosHome from '@/components/IconosHome.vue'

  import ProductFeatured from '@/components/ProductFeatured.vue'

  import Slider from '@/components/Slider.vue'

  import { SlideXRightTransition } from 'vue2-transitions'


  export default {
    name: 'home',
    components: {
      Eheader,
      Efooter,
      IconosHome,
      CategoriasProducto,
      SlideXRightTransition,
      Slider,
      ProductFeatured,
      Products
    },
    data() {
      return {
        data: {
          cat: null
        },
        loading: false,
        populares: []
      }
    },
    created() {
      this.$store.state.filterCat = null
    },
    mounted() {
      axios.get(this.$store.state.dominio + '/api/articulos/populares?limit=8').then(response => {
          this.populares = response.data.articulos;
      }).catch(error => { console.error(error); });
    },
  }
</script>

<style scoped>
.recommended-section {
  padding: 5rem 0;
  background: linear-gradient(135deg, #fdfbfb 0%, #ebedee 100%);
  position: relative;
  overflow: hidden;
  border-top: 1px solid #eaeaea;
}
.btn-premium {
  display: inline-block;
  background: linear-gradient(45deg, #713083, #cc161d);
  color: white;
  padding: 14px 36px;
  border-radius: 50px;
  font-weight: 700;
  text-decoration: none;
  text-transform: uppercase;
  letter-spacing: 1px;
  box-shadow: 0 4px 15px rgba(113, 48, 131, 0.4);
  transition: all 0.3s ease;
  border: 2px solid transparent;
}
.btn-premium:hover {
  transform: translateY(-3px);
  box-shadow: 0 8px 25px rgba(204, 22, 29, 0.5);
  background: linear-gradient(45deg, #cc161d, #713083);
  color: white;
  text-decoration: none;
}
.section-header h2 {
  text-shadow: 1px 1px 2px rgba(0,0,0,0.05);
}
</style>
